module.exports = __webpack_public_path__ + "img/31-warning--dark.5ada08e3.svg";